// extracted by mini-css-extract-plugin
module.exports = {"fileWrapper":"_2IvZp","uploadWrapper":"_1IYrx"};